import Button from 'components/base/Button'
import { FC } from 'lib/component-utils'
import { useIntl } from 'lib/intl-utils'
import Container from 'components/landing/Container'

const ExtensionPlug: FC<{
  title?: string
  description?: string
  href?: string
  imageAlt?: string
  image?: string
}> = ({
  title = 'Попробуйте бесплатное расширение Sellmonitor',
  description = 'Расширение покажет данные о продажах, выручке, рекламные позиции, ставки в поиске и многое другое — прямо на сайтах Wildberries и Ozon',
  href = 'https://chromewebstore.google.com/detail/sellmonitor/nlldhlipbgolknjpcihjdobjjngeejag',
  imageAlt = 'Sellmonitor Extension',
  image = '/next/img/landing/extension.png',
}) => {
  const { t } = useIntl()

  return (
    <Container
      data-header-theme="dark"
      className="!pt-12 !pb-14 relative overflow-hidden text-white [background:linear-gradient(180deg,#0000007f,#0000007f),linear-gradient(180deg,rgb(23,37,84),rgb(23,37,84))] bg-no-repeat bg-center selection:!bg-blue-600 isolate"
    >
      <div className="w-full relative px-2 sm:px-10 lg:px-8">
        <h2 className="text-2xl font-medium">{title}</h2>
        <div className="mt-4 space-y-1 text-base">
          <p className="max-w-[65ch]">{description}</p>
        </div>
        <Button
          as="a"
          target="_blank"
          rel="noreferrer nofollow"
          href={href}
          theme="primary"
          className="!bg-gradient-to-tr from-sky-300 to-blue-300 hover:brightness-105 focus:ring-offset-gray-900 focus:ring-blue-300 !text-black mt-8"
        >
          {t`install_extension`}
        </Button>

        <div className="absolute top-12 right-28 hidden xl:block">
          <img
            src={image}
            alt={imageAlt}
            className="h-[468px] w-[251px] shadow-xl rounded-xl ring-1 ring-black/10"
          />
        </div>
        <div className="absolute -top-56 -right-16 hidden xl:block">
          <img
            src={image}
            alt={imageAlt}
            className="h-[468px] w-[251px] shadow-xl rounded-xl ring-1 ring-black/10"
          />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1024 1024"
          className="absolute top-[-50%] left-[90%] -z-10 min-h-[64rem] min-w-[64rem] h-[64rem] w-[64rem] -translate-x-1/2"
          aria-hidden="true"
        >
          <circle
            cx={512}
            cy={512}
            r={512}
            fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)"
            fillOpacity="0.7"
          />
          <defs>
            <radialGradient
              id="827591b1-ce8c-4110-b064-7cb85a0b1217"
              cx={0}
              cy={0}
              r={1}
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(512 512) rotate(90) scale(512)"
            >
              <stop stopColor="#0062ff" />
              <stop offset={1} stopColor="#0062ff" stopOpacity={0} />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </Container>
  )
}

export default ExtensionPlug
